// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2VE4R","infoBtn":"quickbooks_infoBtn__1zUjb","formBox":"quickbooks_formBox__dtyji","formFooter":"quickbooks_formFooter__1Lh8P"};